export enum EquipmentType {
  anpr,
  bluetooth,
  fcd,
  infrarood,
  laser,
  lus,
  microwave,
  radar,
  telslang,
  videodetectie,
  vri,
  datafusie,
  overig
}



// WEBPACK FOOTER //
// ./src/app/models/enums/equipmenttype.ts